import { api } from '../index';
import { TAxiosResponse } from '../baseApiTypes';
import { ICountriesResponse } from './types';

export const getCountries = (): TAxiosResponse<ICountriesResponse> =>
  api.get('/countries');

export const CountriesApi = {
  getCountries,
};
